import { createFileRoute } from '@tanstack/react-router';

import { AccountSettingsPage } from '../features/account/account-settings-page.js';

export const Route = createFileRoute('/_authed/account/profile')({
  component: () => <AccountSettingsPage section="profile" />,
});
